var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWithToogleAndroidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 9.5,
    stroke: "#0195D3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53962 9.19384C9.23029 9.50973 9.05127 10.0015 9.05127 10.6384V33.3567C9.05127 33.9936 9.23029 34.4854 9.53962 34.8013L9.61597 34.8706L22.666 22.1452V21.8447L9.61597 9.11936L9.53962 9.19384Z",
    fill: "#0195D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5914 26.3906L24.2462 22.1467V21.8462L28.5967 17.6023L28.6941 17.6575L33.8462 20.5172C35.3165 21.3287 35.3165 22.6642 33.8462 23.4809L28.6941 26.3354L28.5914 26.3906Z",
    fill: "#0195D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9038 27.1255L23.456 22.7866L10.3296 35.5929C10.8179 36.0937 11.6143 36.154 12.52 35.6532L27.9038 27.1255Z",
    fill: "#0195D3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9038 16.87L12.52 8.34235C11.6143 7.84669 10.8179 7.90704 10.3296 8.40784L23.456 21.209L27.9038 16.87Z",
    fill: "#0195D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithToogleAndroidIcon);
export default __webpack_public_path__ + "static/media/with-toogle-android-icon.22561d523b7517c40382ccaa002f4d3d.svg";
export { ForwardRef as ReactComponent };